import {useGetSessionUser} from '../../ui/core/use-get-session-user';
import {useUpdateDismissibleUserSetting} from '../../ui/core/use-update-dismissible-user-setting';

// Used for showing and hiding banners/modals/etc. for a given user.
//
// Example usage:
// const {shouldShow, onDismiss} = useDismissibleUserSetting('hide_competitor_iq_get_started');
//
// NOTE: Setting name needs to be added to Nut\Settings\User.php
export const useDismissibleUserSetting = (
    settingName: string
): {
    shouldShow: boolean;
    onDismiss?: () => Promise<any>;
    isLoading: boolean;
} => {
    const {user, isLoading} = useGetSessionUser();
    const updateDismissibleUserSetting = useUpdateDismissibleUserSetting();

    const shouldShow = Boolean(
        user && user.dismissedSettings && !user.dismissedSettings.includes(settingName)
    );

    const onDismiss = user
        ? () =>
              updateDismissibleUserSetting({
                  userId: user.id,
                  settingName: settingName,
                  value: '1',
              })
        : undefined;

    return {shouldShow, isLoading, onDismiss};
};
